import styled from 'styled-components';

export const FooterContent = styled.footer`
  margin: 0;
  padding: 20px 0;
  background: #00abc1;

  > p {
    color: #f2ec25;
    font-family: Shlop, sans-serif;
    font-size: 20px;
    text-align: center;
  }
`;